import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const AnalyticsModeSwitch: React.FC = () => {
  const location = useLocation();
  const isInsightsMode = location.pathname === '/insights' || location.pathname === '/deep';

  return (
    <nav className="analytics-mode-switch" aria-label="Analytics mode switch">
      <Link className={`analytics-mode-link ${!isInsightsMode ? 'active' : ''}`} to="/">
        基本ダッシュボード
      </Link>
      <Link className={`analytics-mode-link ${isInsightsMode ? 'active' : ''}`} to="/insights">
        運営インサイト
      </Link>
    </nav>
  );
};

export default AnalyticsModeSwitch;
